import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { EReportCreationType } from 'src/app/domain/Analyse/enum/report-type';
import { ELacProcessTypes } from 'src/app/domain/Lac - EAU/enum/lac-process-types';
import { LacProcess } from 'src/app/domain/Lac - EAU/lac-process';
import { EInterventionType } from 'src/app/domain/planning/enum/intervention-type';
import { Intervention } from 'src/app/domain/planning/intervention';
import { Document } from 'src/app/domain/Shared/document';
import { ENavigationRoute } from 'src/app/models/enum/navigation-route';
import { AnalyseService } from 'src/app/services/analyse-service';
import { DocumentService } from 'src/app/services/document.service';
import { InterventionService } from 'src/app/services/intervention.services';
import { LacService } from 'src/app/services/lac.service';
import { CoreData } from 'src/app/tools/core-data';
import { NotificationManager } from 'src/app/tools/notification-manager';
import { ConfirmBoxDialog } from 'src/app/tools/ui/confirm-box/confirm-box.component';
import { ConfirmBoxModel } from 'src/app/tools/ui/confirm-box/confirm-box.model';
import { EDocumentType } from 'src/app/tools/ui/mutilple-file-upload-box/document-type';
import { MultipleFileUploadBoxDialog } from 'src/app/tools/ui/mutilple-file-upload-box/multiple-file-upload-box';
import { StringConverter } from 'src/app/tools/ui/string-converter';

enum ENavigationIntervention {
    Back,
    Current,
    Next
}

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'app-documents',
    templateUrl: './documents.component.html',
    styleUrls: ['./documents.component.scss']
})
export class DocumentsComponent implements OnInit {
    ENavigationIntervention = ENavigationIntervention;
    EInterventionType = EInterventionType;
    EReportCreationType = EReportCreationType;
    ELacProcessTypes = ELacProcessTypes;
    EDocumentype = EDocumentType;
    PictureList: Document[] = [];
    ReportList: Document[] = [];
    OtherDocumentList: Document[] = [];
    public SearchText: string;
    public Intervention: Intervention;
    private process: LacProcess;

    get CanSearch() {
        if (this.SearchText && this.SearchText.length > 2) {
            return true;
        }
        return false;
    }

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private snackBar: MatSnackBar,
        private interventionService: InterventionService,
        private documentService: DocumentService,
        private analysisService: AnalyseService,
        private lacService: LacService,
        private coreData: CoreData,
        private dialog: MatDialog) { }

    async ngOnInit(): Promise<void> {
        if (this.coreData.LastInterventionLoadedInDocument) {
            this.SearchText = this.coreData.LastInterventionLoadedInDocument;
            await this.getAllDocuments();
        }
        this.coreData.CurrentPageName = "";
    }

    canGenerateDocuments() {
        if (this.Intervention) {
            return true;
        }
        return false;
    }

    IsInProcess(type: ELacProcessTypes) {
        return this.process && this.process.Is(type);
    }

    getDocumentTypeName(documentType: EDocumentType) {
        return StringConverter.getDocumentTypeName(documentType);
    }

    hasPreleveurRight() {
        if (this.coreData.RoleAndPermissions?.find(x => x.Name === 'CanTakeIBMRSamples') ||
            this.coreData.RoleAndPermissions?.find(x => x.Name === 'CanTakeIMLSamples') ||
            this.coreData.RoleAndPermissions?.find(x => x.Name === 'CanTakeMGCESamples') ||
            this.coreData.RoleAndPermissions?.find(x => x.Name === 'CanTakeMPCESamples') ||
            this.coreData.RoleAndPermissions?.find(x => x.Name === 'CanTakeEauSamples') ||
            this.coreData.RoleAndPermissions?.find(x => x.Name === 'CanTakeIBDSamples') ||
            this.coreData.RoleAndPermissions?.find(x => x.Name === 'CanTakeIBDLacSamples') ||
            this.coreData.RoleAndPermissions?.find(x => x.Name === 'CanTakeIBGNSamples')) {
            return true;
        }
    }

    hasTraiteurTrieur() {
        if (this.coreData.RoleAndPermissions?.find(x => x.Name === 'CanPrepareDiatomees') ||
            this.coreData.RoleAndPermissions?.find(x => x.Name === 'CanPrepareMacroinvertebres'))
            return true;
    }

    hasLABGTA41() {
        if (this.coreData.RoleAndPermissions?.find(x => x.Name === 'CanEditRapportHydrobiologie')) {
            return true;
        }
    }

    hasLABGTA29() {
        if (this.coreData.RoleAndPermissions?.find(x => x.Name === 'CanEditRapportEau')) {
            return true;
        }
    }

    async getAllDocuments() {

        this.PictureList = [];
        this.ReportList = [];
        this.OtherDocumentList = [];
        const x = await this.documentService.getAllDocumentByFilter(this.SearchText).toPromise();

        this.coreData.LastInterventionLoadedInDocument = x.SampleCode;
        this.Intervention = x;
        this.PictureList = x.Documents.filter(d => d.DocumentType >= 1 && d.DocumentType <= 5);
        this.ReportList = x.Documents.filter(d => (
            (d.DocumentType >= 10 && d.DocumentType <= 12) ||
            (d.DocumentType >= 16 && d.DocumentType <= 18) ||
            (d.DocumentType >= 26 && d.DocumentType <= 31) ||
            (d.DocumentType >= 36 && d.DocumentType <= 37) ||
            (d.DocumentType >= 40 && d.DocumentType <= 41))
            && d.Version === _.max(x.Documents.filter(y => y.DocumentType === d.DocumentType).map(z => z.Version)));
        this.OtherDocumentList = x.Documents.filter(d =>
            (((d.DocumentType >= 6 && d.DocumentType <= 9) || d.DocumentType === 42 || d.DocumentType === 43 ||
                (d.DocumentType >= 13 && d.DocumentType <= 15) || d.DocumentType >= 19 && d.DocumentType <= 20) ||
                ((d.DocumentType >= 10 && d.DocumentType <= 12) || (d.DocumentType >= 16 && d.DocumentType <= 18)) &&
                d.Version !== _.max(x.Documents.filter(y => y.DocumentType === d.DocumentType).map(z => z.Version))) ||
            (d.DocumentType >= 21 && d.DocumentType <= 25) ||
            (d.DocumentType >= 32 && d.DocumentType <= 34) ||
            (d.DocumentType >= 38 && d.DocumentType <= 39));

        if (this.Intervention.Type === EInterventionType.LAC) {
            this.process = await this.lacService.getLacProcessByCode(this.Intervention.ProcessCode).toPromise();
        }
    }

    getDocumentFile(document: Document) {
        this.documentService.getDocumentByIntervention(this.Intervention.Code, document.Code).subscribe(x => {
            this.promptFile(x);
        });
    }

    promptFile(x: any) {
        var url = window.URL.createObjectURL(x.body);
        var a = document.createElement('a');

        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        var matches = filenameRegex.exec(x.headers.get('Content-Disposition'));
        if (matches != null && matches[1]) {
            a.download = matches[1].replace(/['"]/g, '');
        }

        a.href = url;
        // a.download = x.fileName;
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove();  //afterwards we remove the element again 
    }

    generateReport(type: EReportCreationType, reason?: string) {
        this.analysisService.generateReport(this.Intervention.Code, type, reason).subscribe(x => {
            if (x) {
                if (typeof (x) === 'boolean') {
                    NotificationManager.handleSuccess('Rapport généré', this.snackBar);
                    this.getAllDocuments();
                } else { // Trop de taxon ? MPCE RE
                    NotificationManager.handleWarning(x, this.snackBar);
                }
            }
        });
    }

    searchIntervention() {
        this.getAllDocuments();
    }

    checkAndWarnForExistingDocument(type: EDocumentType) {

        if ([...this.ReportList, ...this.OtherDocumentList, ...this.PictureList].every(x => x.DocumentType !== type)) {
            this.openMultipleUploadDialog(type);
            return;
        }

        const m: ConfirmBoxModel = new ConfirmBoxModel();
        m.QuestionTitle = 'Un document de ce type existe déjà, voulez l\'écraser ?';
        m.WithReason = false;
        const dialogRef = this.dialog.open(ConfirmBoxDialog, {
            data: m,
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: ConfirmBoxModel) => {
            if (result) {
                this.openMultipleUploadDialog(type)
            }
        });
    }

    openMultipleUploadDialog(type: EDocumentType) {
        const dialogRef = this.dialog.open(MultipleFileUploadBoxDialog, {
            data: { code: this.Intervention.Code, type, isForImport: false },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.getAllDocuments();
            }
        });
    }

    navigateToIntervention(whereToGo: ENavigationIntervention) {
        if (!this.Intervention) {
            return;
        }

        if (whereToGo === ENavigationIntervention.Back) {
            this.SearchText = _.first(this.Intervention.PreviousSampleCodes);
            this.getAllDocuments();
            return;
        }
        if (whereToGo === ENavigationIntervention.Next) {
            this.SearchText = _.first(this.Intervention.NextSampleCodes);
            this.getAllDocuments();
            return;
        }

        this.coreData.CurrentIntervention = this.Intervention;
        this.router.navigate([ENavigationRoute.InterventionDashboard, { type: this.Intervention.Type, interventionCode: this.Intervention.Code }]);
    }

    checkIfReportCanBeGenerated(type: EReportCreationType) {
        if ((type === EReportCreationType.RapportEssai
            && this.ReportList.find(r => r.DocumentType === EDocumentType.RapportEssaiPDF)
            && this.Intervention.Type !== EInterventionType.EAU)) {
            this.openConfirmDialog(type);
        } else if (type === EReportCreationType.SaisieMinvCE
            || type === EReportCreationType.SaisieMPhytCE
            || type === EReportCreationType.SoutienDiat
            || type === EReportCreationType.SoutienMinvCE
            || type === EReportCreationType.RapportEssaiLacPhyto) {
            this.generateReport(type);
        } else {
            this.generateReport(type);
        }
    }

    // openBoxtextDialog(type: EReportCreationType) {

    //   const dialogRef = this.dialog.open(EditTextBoxDialog, {
    //     width: '666px',
    //     data: { title: 'Code Producteur', text: '' }
    //   });

    //   dialogRef.afterClosed().subscribe((result: string) => {
    //     if (result) {
    //       this.generateReport(type, result);
    //     }
    //   });
    // }

    openConfirmDialog(type: EReportCreationType) {
        const m: ConfirmBoxModel = new ConfirmBoxModel();
        m.QuestionTitle = 'Voulez-vous générer une nouvelle version ? Si oui, merci de préciser la cause du changement, ce qui a été modifié et la ou les pages concernées ?';
        m.WithReason = true;
        m.WithLengthValidation = true;
        const dialogRef = this.dialog.open(ConfirmBoxDialog, {
            data: m,
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: ConfirmBoxModel) => {
            if (result) {
                this.generateReport(type, result.Reason);
            }
        });
    }

    checkCOFRAC() {

        if (!this.Intervention.COFRAC) {
            this.openCOFRACWarningDialog();
        } else {
            this.changeCOFRAC();
        }
    }

    openCOFRACWarningDialog() {

        const m: ConfirmBoxModel = new ConfirmBoxModel();
        m.QuestionTitle = 'Raison retrait du cofrac ?';
        m.WithReason = true;
        m.WithLengthValidation = true;
        const dialogRef = this.dialog.open(ConfirmBoxDialog, {
            data: m,
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: ConfirmBoxModel) => {
            if (result) {
                this.changeCOFRAC(result.Reason);
            } else {
                this.Intervention.COFRAC = !this.Intervention.COFRAC;
            }
        });
    }

    changeCOFRAC(reason?: string) {
        this.interventionService.changeCOFRAC(this.Intervention.Code, this.Intervention.COFRAC, reason).subscribe(x => {
            if (this.Intervention.COFRAC) {
                NotificationManager.handleSuccess('Cofrac ajouté sur l\'intervention', this.snackBar);
            } else {
                NotificationManager.handleSuccess('Cofrac retiré de l\'intervention', this.snackBar);
            }
        });
    }
}
